import Preloader from '../modules/components/preloader';
import Animation from '../modules/animation/animation';
import device from '../modules/utils/device';
import initLenis from '../modules/utils/lenis';
import '../../scss/styles.scss';

async function entry() {
  const lowPower = await device.isLowPower;

  if (!device.isMobile && !lowPower) {
    initLenis();
  }

  new Preloader('.site-preloader', 1000, () => console.log('Page loaded'))
    .then(() => new Animation('.site-animation', 150));

}

document.addEventListener('DOMContentLoaded', entry);
